module.exports = __webpack_public_path__ + "img/BRAVO_7.31120bc5.jpg";